import { render } from "./DetailGaleri.vue?vue&type=template&id=195ed4d5"
import script from "./DetailGaleri.vue?vue&type=script&lang=js"
export * from "./DetailGaleri.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__